import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { FeatureTourStepEnum } from '../../shared/feature-tour-step.enum';
import { FeatureTourService } from '../../shared/feature-tour.service';

@Component({
  selector: 'app-nothing-to-search',
  templateUrl: './nothing-to-search.component.html',
  styleUrls: ['./nothing-to-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NothingToSearchComponent implements OnDestroy {
  popoverDisplayed = false;
  FeatureTourStepEnum = FeatureTourStepEnum;

  private subscriptions: Subscription = new Subscription();

  constructor(public featureTourService: FeatureTourService) {
    this.subscriptions.add(
      featureTourService.featureTourStepBS.subscribe(value => {
        if (value) {
          this.popoverDisplayed = [FeatureTourStepEnum.START, FeatureTourStepEnum.FIRST_USE].includes(value);
        } else {
          this.popoverDisplayed = false;
        }
      })
    );
  }

  startTour() {
    this.featureTourService.featureTourStepBS.next(FeatureTourStepEnum.START);
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
